module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/6_03d4827bf6ee3ed470d071c58939a9a3.png";